export default "__VITE_ASSET__DGKBLDxr__"